// Facility to initialize asynchronously loaded views:
// * Detail Views
// * Search Views
// * Dashboard Views (under flag)

const viewInitFns = [];

function addCallback(fn) {
	viewInitFns.push(fn);
}

function runCallbacks(ctx) {
	for (var i = 0; i < viewInitFns.length; i++)
		viewInitFns[i](ctx);
}

export { addCallback, runCallbacks };